export default function Contact() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-secondary-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-secondary-200 text-secondary-700 text-xs font-semibold rounded-full uppercase tracking-wide">
            联系我们
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">联系桔子视频</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            资源反馈、内容建议、合作咨询，欢迎随时与我们取得联系。
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-secondary-200/60">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto rounded-xl bg-primary-500 flex items-center justify-center">
                <i className="ri-mail-line text-background-50 text-xl"></i>
              </div>
              <h3 className="mt-4 text-sm font-bold text-foreground-950">邮件联系</h3>
              <p className="mt-1 text-xs text-foreground-500">juzivideo@contact.com</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto rounded-xl bg-accent-500 flex items-center justify-center">
                <i className="ri-chat-3-line text-background-50 text-xl"></i>
              </div>
              <h3 className="mt-4 text-sm font-bold text-foreground-950">内容反馈</h3>
              <p className="mt-1 text-xs text-foreground-500">发现片源问题？随时告诉我们</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto rounded-xl bg-secondary-500 flex items-center justify-center">
                <i className="ri-service-line text-background-50 text-xl"></i>
              </div>
              <h3 className="mt-4 text-sm font-bold text-foreground-950">合作洽谈</h3>
              <p className="mt-1 text-xs text-foreground-500">商务合作请发送邮件详谈</p>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-background-200">
            <p className="text-center text-xs text-foreground-400 leading-relaxed">
              桔子视频的持续运营离不开每一位用户的支持。如果您发现任何片源问题、播放异常或有好的建议，
              欢迎随时通过以上渠道联系。我们会在24小时内响应您的反馈，不断优化观影体验。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}